export default "__VITE_ASSET__S19ygtfM__"